module.exports = __webpack_public_path__ + "assets/img/tx101c_3.47d91bca.jpg";